<template>
  <div class="body">
    <div style="margin-top: 0vh;">
      <el-form
          ref="form"
          :model="params"
          class="form"
          label-width="80px">
        <el-form-item label="需求日期" prop="startTime" style="float: left">
          <el-date-picker
              v-model="params.startTime"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              style="width:125px"
              type="date"
              placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="配料日期" prop="stockTime" style="float: left">
          <el-date-picker
              v-model="params.stockTime"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              style="width:125px"
              type="date"
              placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="完成日期" prop="finishTime" style="float: left">
          <el-date-picker
              v-model="params.finishTime"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              style="width:125px"
              type="date"
              placeholder="选择日期"/>
        </el-form-item>
        <!--        <el-form-item label="产线" prop="productType" style="float: left">-->
        <!--          <el-select v-model="params.productType" placeholder="请选择" @change="typeChange">-->
        <!--            <el-option-->
        <!--                v-for="item in materialTypeList"-->
        <!--                :key="item.pkid"-->
        <!--                :label="item.materialTypeName"-->
        <!--                :value="item.pkid"/>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item label="领料车间" style="float: left">
          <el-select
              v-model="materialTypeList"
              :popper-append-to-body="false"
              class="biddingStageSty"
              multiple
              clearable
              placeholder="请选择"
              @change="handleSelectMaterialType">
            <el-option
                v-for="item in materialTypeOptions"
                :key="item.pkId"
                :label="item.warehouseAreaName"
                :value="item.pkId"/>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="检验类型" prop="productType" style="float: left;margin-left: 5px">-->
        <!--          <el-select v-model="params.productType" placeholder="请选择" style="width: 100px;">-->
        <!--            <el-option label="首检" :value="30"/>-->
        <!--            <el-option label="巡检" :value="50"/>-->
        <!--            <el-option label="来料检" :value="10"/>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="查询方式" prop="queryType" style="float: left;margin-left: 5px">-->
        <!--          <el-select v-model="params.queryType" placeholder="请选择" style="width: 100px;">-->
        <!--            <el-option label="日" :value="0"/>-->
        <!--            <el-option label="周" :value="1"/>-->
        <!--            <el-option label="月" :value="2"/>-->
        <!--            <el-option label="年" :value="3"/>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
      </el-form>
      <div style="float: left; margin-left: 5px;">
        <el-button @click="params=$options.data().params">清空</el-button>
        <el-button :loading="submitLoading" type="primary" @click="getList">查询</el-button>
        <!--        <el-button :loading="exportLoading" type="success" @click="exportExcel">导出</el-button>-->
      </div>
    </div>
    <div style="margin-top: 5vh">
      <el-table :data="model">
        <el-table-column prop="materialTypeName" label="领料车间" width="250px"/>
        <el-table-column prop="stockUserName" label="配料人"/>
        <el-table-column prop="requireDate" label="需求日期"/>
        <el-table-column prop="stockTypeName" label="单据类型"/>
        <el-table-column prop="requireQty" label="需求数量">
          <template slot-scope="scope">
            <span v-if="scope.row.requireQty>0"
                  style="color: #2d8cf0;cursor: pointer;"
                  @click="getPlanPosted(scope.row,0)">
                                        {{ scope.row.requireQty }}
                                      </span>
            <span v-else>{{ scope.row.requireQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="completeQty" label="完成数量">
          <template slot-scope="scope">
            <span v-if="scope.row.completeQty>0"
                  style="color: #2d8cf0;cursor: pointer;"
                  @click="getPlanPosted(scope.row,1)">
                                        {{ scope.row.completeQty }}
                                      </span>
            <span v-else>{{ scope.row.completeQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unCompleteQty" label="未完成数量">
          <template slot-scope="scope">
            <span v-if="scope.row.unCompleteQty>0 &&scope.row.requireDate<curDate"
                  style="color: #d81e19;cursor: pointer;"
                  @click="getPlanPosted(scope.row,2)">
                                        {{ scope.row.unCompleteQty }}
                                      </span>
            <span v-else-if="scope.row.unCompleteQty>0 &&scope.row.requireDate>=curDate"
                  style="color: #2d8cf0;cursor: pointer;"
                  @click="getPlanPosted(scope.row,2)">
                                        {{ scope.row.unCompleteQty }}
            </span>
            <span v-else>{{ scope.row.unCompleteQty }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nextDayRequireQty" label="次日需求数量">
          <template slot-scope="scope">
            <span
                v-if="scope.row.nextDayRequireQty>0"
                style="color: #2d8cf0;cursor: pointer;"
                @click="getPlanPosted(scope.row,3)">
                                        {{ scope.row.nextDayRequireQty }}
                                      </span>
            <span v-else>{{ scope.row.nextDayRequireQty }}</span>
          </template>
        </el-table-column>
      </el-table>
      <stock-rpt-detail-list ref="detailList"/>
    </div>
  </div>
</template>

<script>
import constant from "@/util/constant";
import moment from "moment";
import StockRptDetailList from "@/views/Report/StockRpt/StockRptDetailList";

export default {
  name: "StockRpt",
  components: {
    StockRptDetailList,
  },
  data() {
    return {
      constant,
      submitLoading: false,
      exportLoading: false,
      curDate: moment().subtract(2, "days").format("YYYY-MM-DD"),
      pickerOptions: {
        disabledDate: time => {
          return this.dealDisabledDate(time);
        },
      },
      params: {
        startTime: "",
        stockTime: "",
        finishTime:"",
        productType: "",
        productTypeName: "",
        queryType: 0,
        searchType: 0,
      },
      params2: {
        startTime: "",
        stockTime: "",
        finishTime:"",
        queryType: 0,
        materialTypeName: "",
        stockTypeName: "",
      },
      model: [],
      materialTypeList: [],
      materialTypeOptions: [],
      maxPunctuality: "",
    };
  },
  mounted() {
    this.getMaterialTypeList();
  },
  methods: {
    getMaterialTypeList() {
      this.$http.get("basic", "warehouseAreas/list").then((res) => {
        if (res.success) {
          this.materialTypeOptions = res.data;
        }
      });
    },
    handleSelectMaterialType(value) {
      if (value.length) {
        // this.materialTypeList = value;
        this.params.productType = value.join(",");
      } else {
        // this.materialTypeList = [];
        this.params.productType = "";
      }
    },
    typeChange(id) {
      this.params.productTypeName = this.materialTypeList.find(s => s.pkid === id).materialTypeName;
    },
    getList() {
      // if (!this.params.startTime || !this.params.endTime) {
      if (!this.params.startTime) {
        this.$message.error("请选择需求日期");
        return;
      }
      if(!this.params.stockTime){
        this.params.stockTime="";
      }
      if(!this.params.finishTime){
        this.params.finishTime="";
      }

      this.submitLoading = true;
      this.$http
          .get("basic", "stockRpt/stockReport_V1", this.params)
          .then((res) => {
            console.log(res);
            this.model = res.data;
            this.submitLoading = false;
            // this.$message.success("获取成功");
          })
          .catch(() => {
            this.submitLoading = false;
            // this.$message.error("获取失败");
          });
    },

    getPlanPosted(item, num) {
      if(!this.params.stockTime){
        this.params.stockTime="";
      }
      if(!this.params.finishTime){
        this.params.finishTime="";
      }
      this.params2.startTime = item.requireDate;
      this.params2.stockTime = this.params.stockTime;
      this.params2.finishTime = this.params.finishTime;
      this.params2.queryType = num;
      this.params2.materialTypeName = item.materialTypeName;
      this.params2.stockTypeName = item.stockTypeName;
      this.$refs.detailList.open(this.params2);
      // this.$refs.workOrderDetailList.open(params.startTime, params.endTime, num, this.params.productType, this.params.queryType, this.params.searchType);
    },
    //导出
    exportExcel() {
      this.exportLoading = true;
      this.$http
          .exportFile("basic", "productReports/workOrderPunctualityReportExport", this.params, 60 * 10000)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
    },
    dealDisabledDate(time) {
      return (
          // time.getTime() > new Date((new Date().getTime() - 24 * 60 * 60 * 1000)).getTime()
          time.getTime() > new Date((new Date().getTime())).getTime()
      );
    },
    dialogClose() {
    },
  },
};
</script>
<style lang="scss" scoped>
.body {
  //height: 160vh;

  .table-left {
    width: 100%;
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-collapse: collapse;

    tr {
      td {
        font-size: 15px;
        text-align: center;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 10px 0;
        font-weight: bold;
      }
    }
  }

  .table-right {
    border-top: 1px solid #ddd;
    border-left: 0;
    border-collapse: collapse;

    tr {
      td {
        font-size: 15px;
        text-align: center;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 10px 0;

      }

      td .cycleName {
        width: 95px;
      }
    }
  }

  .vm-main .vm-main-page {
    background-color: #fff;
  }

  .shipmentRate {
    width: 60%;
    /*margin: 0 auto 5px auto;*/
    background: #2D8CF0;
    position: absolute;
    bottom: 0;
    left: 20%;
  }
}
</style>
